<div class="d-flex align-items-center gap-1 inline-stepper">
  <button type="button" class="btn btn-outline-secondary btn-sm" (click)="decrement()" [disabled]="disabled">
    <i class="bi bi-dash"></i>
  </button>

  <input
    type="text"
    class="form-control form-control-sm text-center stepper-input"
    [formControl]="timeControl"
    placeholder="HH:mm"
  />

  <button type="button" class="btn btn-outline-secondary btn-sm" (click)="increment()" [disabled]="disabled">
    <i class="bi bi-plus"></i>
  </button>

  <button
    type="button"
    class="btn btn-success btn-sm ms-2"
    (click)="onConfirm()"
    [disabled]="timeControl.invalid || disabled">
    OK
  </button>

  <button
    type="button"
    class="btn btn-outline-secondary btn-sm"
    (click)="onCancel()"
    [disabled]="disabled">
    Annulla
  </button>
</div>
